import React, { Component } from 'react';
import { Link, navigate } from 'gatsby';
import Image from 'gatsby-image';
import PropTypes from 'prop-types';

const getPrice = (prices) => {
  const month = new Date().getMonth();
  return prices[month];
};

class Card extends Component {
  get price() {
    const month = new Date().getMonth();
    const { prices } = this.props;
    return prices[month];
  }

  render() {
    const {
      title, promo, prices, photos, order, reserved,
    } = this.props;
    return (
      <div
        className="card"
        onClick={(e) => {
          !reserved && navigate(`/room/${order}/`);
        }}
      >
        {reserved && <span className="card-badge reserved">зарезервировано</span>}
        <Image className="card-thumb" loading="lazy" fluid={photos[0].fluid} alt={title} />
        <div className="card-body">
          <h3 className="title-3">{title}</h3>
          <p className="paragraph">{promo}</p>
          {!reserved && (
            <div className="card-price">
              <span className="card-currency">₽</span>
              {getPrice(prices)}
            </div>
          )}
          {!reserved && (
            <Link to={`/room/${order}/`} className="btn popup-trigger">
              Посмотреть
            </Link>
          )}
        </div>
      </div>
    );
  }
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  promo: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired,
  reserved: PropTypes.bool.isRequired,
  prices: PropTypes.arrayOf(PropTypes.string).isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Card;
